import React, { useState } from "react";
import GetAMentor from "../../../../assets/images/get-a-mentor.png";
// import ApplyGetMentor from "../../../../assets/images/apply-get-mentor.png";
import ApplyGetMentor from "../../../../assets/images/Purple button Rectangle.svg";
// import IamEligible from "../../../../assets/images/am-i-eligible.png";
import IamEligible from "../../../../assets/images/Blue_Button_Rectangle.svg";
import "./style.css";
import "./style.scss";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import HTMLReactParser from "html-react-parser";
import { useTranslation } from "react-i18next";
import swal from "sweetalert";
const WhoGetMentor = (props) => {
  const { t } = useTranslation();
  const history = useHistory();
  const [isShowLogin, setIsShowLogin] = useState(false);
  // const handleLoginClick = () => {
  //   history.push({
  //     pathname: "/startup-form",
  //   });
  // };
  const handleLoginClick = (buttonAction) => {
    //   swal("Please stay tuned, this function will be enabled shortly after the launch of startup onboarding process",
    //   {closeOnClickOutside: false}

    // );
    try {
      if (localStorage.getItem("loggedIn") === "true") {
        let value = localStorage.getItem("SavedLoggedInData");
        //
        let LoginFormData = JSON.parse(value);
        //
        if (
          LoginFormData?.role == "Startup" &&
          LoginFormData?.role === buttonAction
        ) {
          if(LoginFormData?.applicationStatus != "PENDING")
          {
            history.push({
              pathname: "/dashboard",
              state: LoginFormData,
            });
             
          }
          else {
            history.push({
              pathname: "/get-a-mentor",
              state: LoginFormData,
            });
          }
         
        }
        // else if (
        //   LoginFormData?.role == "Mentor" &&
        //   LoginFormData?.role === buttonAction
        // ) {
        //   history.push({
        //     pathname: "/become-a-mentor",
        //     state: LoginFormData,
        //   });
        // }
        else {
          // alert("You have Already Logged In with "+buttonAction)

          toast.error(
            "You have Already Logged In with " +
              LoginFormData?.role +
              ", Logout First..."
          );
        }
        // history.push({
        //   pathname: "/get-a-mentor",
        //   state:Data ,
        // });
      } else {
        history.push({
          pathname: "/login",
          state: buttonAction,
        });
      }
    } catch (error) {}

    setIsShowLogin(!isShowLogin);
  };
  const Banner = props.data[0];
  const BannerImage = Banner.BannerImage;
  const BannerTitle = Banner.BannerTitle;
  const BannerSubtitle = Banner.BannerSubtitle;

  return (
    <div>
      <div style={{ marginTop: "70px" }} id="banner">
        <div class="w-100 pt-50 pb-0 position-relative">
          <div class="container">
            <div class="row">
              <div class="col-md-6 col-sm-12 col-lg-6 wow slideInLeft">
                <div
                  class="mckp-img text-center tilt w-100 get-mentor"
                  data-max_tilt="10"
                  data-perspective="1000"
                  data-scale="1"
                  data-speed="700"
                >
                  <img class="img-fluid" src={BannerImage} alt="" />
                </div>
              </div>
              <div class="col-md-6 col-sm-12 col-lg-6 wow slideInRight">
                <div class="content getamentorfirstdiv">
                  <h2
                    style={{ marginTop: "15px" }}
                    class="mb-0 homepageFirstHeader"
                  >
                    {t("Who_Can_Get_a_Mentor")}
                    {/* Who Can Get a Mentor? */}
                  </h2>
                  <br />
                  <div className="homepageFirstDescription">
                    {HTMLReactParser(BannerSubtitle)}
                  </div>
                  <div
                    className="get-mentor"
                    onClick={() => handleLoginClick("Startup")}
                  >
                    <div
                      class="mr-1 top-btn Startup-Application newuserTooltip "
                      style={{ marginRight: "0px" }}
                    >
                      <img
                        // style={{ marginTop: "-6.1%" }}
                        className="getmentorbtndiv1"
                        height="auto"
                        src={ApplyGetMentor}
                        // onClick={() => handleLoginClick("Startup")}
                        alt="Slide 1 Mockup 6"
                      />
                      <div
                        class="centred col-lg-6 col-md-6 col-sm-2"
                        style={{
                          lineHeight: "25px",
                          display: "flex",
                          marginTop: "-3%",
                        }}
                      >
                        Startup Application
                      </div>
                      <span
                        className="tooltiptext  tooltip-bottom"
                        style={{ left: "66px", top: "89px", width: "auto" }}
                      >
                        Click to Apply as a Startup
                      </span>
                    </div>
                    {/* <!-- banner btn --> */}
                    <div class="header-cart-box-banner-btn position-relative d-inline-block ml-1">
                      <div class="tp-caption cart-btn position-relative">
                        {/* <img height="auto" src={IamEligible} alt="" /> */}
                        <div
                          class="mr-1 Startup-Application "
                          style={{ marginRight: "0px" }}
                        >
                          <img
                            className="getmentorbtndiv2"
                            height="auto"
                            width="200px"
                            // style={{ marginTop: "-27px" }}
                            src={IamEligible}
                            alt="Slide 1 Mockup 6"
                          />
                          <div
                            class="centred2 col-lg-12 col-md-6 col-sm-2 getmentorbtn2"
                            // style={{ left: "48%" }}
                          >
                            Am I<br></br>
                            Eligible?
                          </div>
                        </div>
                        <div class="minicart-dropdown-banner-btn">
                          <p
                            style={{ cursor: "default", textAlign: "left" }}
                            class="banner-btn"
                          >
                            <a>
                              {t(
                                "ALL_STARTUPS_RECOGNISED_UNDER_DPIIT_CAN_APPLY_FOR_MENTORSHIP"
                              )}
                              {/* ALL STARTUPS RECOGNISED UNDER DPIIT CAN APPLY FOR
                              MENTORSHIP. */}
                            </a>
                          </p>
                          <p
                            style={{
                              cursor: "default",
                              fontSize: "20px",
                              lineHeight: "25px",
                              textAlign: "left",
                            }}
                          >
                            {t("Under_the_Startup_India_initiative")}
                            {/* Under the Startup India initiative, eligible
                            companies can get recognised as Startups by
                            Department for Promotion of Industry and Internal
                            Trade (DPIIT), in order to access a host of benefits
                            by the Government of India.{" "} */}
                          </p>
                          <p
                            style={{
                              cursor: "default",
                              marginTop: "10px",
                              fontSize: "20px",
                              lineHeight: "25px",
                              textAlign: "left",
                            }}
                          >
                            {t(
                              "An_entity_which_fulfils_the_eligibility_conditions"
                            )}
                            {/* An entity which fulfils the eligibility conditions
                            as notified in G.S.R. 127 (E) issued by DPIIT dated
                            19th February 2019 can apply for DPIIT Recognition
                            on the */}
                            <a
                              href="https://www.startupindia.gov.in/content/sih/en/recognition-page.html"
                              target="_blank"
                              style={{ color: "#0d6efd" }}
                            >
                              {" "}
                              {/* Startup India portal */}
                            </a>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default WhoGetMentor;
